interface ScoreBreakdownProps {
  breakdown: Record<string, any>;
}

const labels: Record<string, string> = {
  stackMatch: "Stack-Match",
  urgencyFit: "SLA-Fit",
  geoFit: "Geo-Fit",
  reliability: "Zuverlässigkeit",
  quality: "Qualität",
};

const maxScores: Record<string, number> = {
  stackMatch: 35,
  urgencyFit: 25,
  geoFit: 10,
  reliability: 15,
  quality: 15,
};

const ScoreBreakdown = ({ breakdown }: ScoreBreakdownProps) => {
  const scoreKeys = ["stackMatch", "urgencyFit", "geoFit", "reliability", "quality"];
  const hasData = scoreKeys.some(key => breakdown[key] !== undefined);

  if (!hasData) return null;

  return (
    <>
      <div className="divider-line" />
      <div>
        <span className="text-micro mb-4 block">Score-Aufschlüsselung</span>
        <div className="space-y-3">
          {scoreKeys.map(key => {
            const value = breakdown[key] || 0;
            const max = maxScores[key] || 100;
            const pct = Math.round((value / max) * 100);

            return (
              <div key={key} className="flex items-center gap-3">
                <span className="text-caption w-28 shrink-0">{labels[key] || key}</span>
                <div className="flex-1 h-1.5 bg-muted rounded-full overflow-hidden">
                  <div
                    className="h-full bg-accent/60 rounded-full transition-all duration-500"
                    style={{ width: `${pct}%` }}
                  />
                </div>
                <span className="text-micro w-12 text-right">{value}/{max}</span>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default ScoreBreakdown;
